import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MdArrowBackIosNew } from 'react-icons/md';
import Cookies from 'js-cookie';
import NavBar from '../../../components/NavBar';
import FormScale from '../../../components/Escala de enfermagem/FormScale';

const EscalaEnfermagem = () => {
	const [showAlert, setShowAlert] = useState(true);
	const [carregando, setCarregando] = useState(true);

	useEffect(() => {
		const localData = Cookies.get('user');
		if (localData) {
			setShowAlert(false);
		}

		const timeoutId = setTimeout(() => {
			setCarregando(false);
		}, 800);

		return () => clearTimeout(timeoutId);
	}, []);

	return (
		<div className='flex flex-col min-h-screen'>
			<NavBar />
			{carregando ? (
				<div
					className='flex justify-center text-center flex-grow mt-52 content-center w-full h-screen'
					role='status'>
					<div className='w-8 h-8 rounded-full border-4 border-[#dbeafe] border-t-[#2563eb] animate-spin' />
				</div>
			) : !showAlert ? (
				<div className='text-center flex-grow'>
					<FormScale />
				</div>
			) : (
				<section className='bg-[#13335A] rounded-md mx-2 sm:w-[50%] sm:mx-auto my-auto'>
					<div className='py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6'>
						<div className='mx-auto max-w-screen-sm text-center'>
							<h1 className='mb-4 text-white text-6xl tracking-tight font-extrabold lg:text-7xl'>
								401
							</h1>
							<p className='mb-10 text-3xl tracking-tight font-bold text-slate-100 md:text-4xl'>
								Acesso Negado
							</p>
							<p className='mb-7 text-lg font-light text-gray-300'>
								Você não possui permissão para acessar este
								campo.
							</p>
						</div>
					</div>
				</section>
			)}
		</div>
	);
};

export default EscalaEnfermagem;
